import { Component } from '@angular/core';

@Component({
  selector: 'app-multimarket',
  templateUrl: './multimarket.component.html',
  styleUrls: ['./multimarket.component.scss']
})
export class MultimarketComponent {

}
